import React, { useState } from 'react';
import { Bar, Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Filler, Tooltip } from 'chart.js';
import { fmtDec, MetricCard, GC, TC } from '../utils';

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Filler, Tooltip);

const COLORS = { 'Peter Povey':'#3ea4b1','Mitch Jankowski':'#7F77DD','Sarah Sutter':'#D4537E','Dan Pena':'#EF9F27' };

export default function AdminPayouts({ data }) {
  const { payouts = [] } = data;
  const [filter, setFilter] = useState('all');

  const total = payouts.reduce((s, p) => s + p.amount, 0);
  const byRep = {};
  payouts.forEach(p => { byRep[p.owner] = (byRep[p.owner] || 0) + p.amount; });
  const repNames = Object.keys(byRep).sort((a, b) => byRep[b] - byRep[a]);
  const largest = payouts.reduce((a, b) => b.amount > a.amount ? b : a, { amount: 0, owner: '', date: '' });

  const repBarData = {
    labels: repNames.map(n => n.split(' ')[0]),
    datasets: [{ data: repNames.map(n => byRep[n]), backgroundColor: repNames.map(n => COLORS[n] || '#888780'), borderRadius: 5, borderSkipped: false }],
  };

  const periods = [...new Set(payouts.map(p => p.date))].sort();
  let running = 0;
  const cumData = periods.map(d => { running += payouts.filter(p => p.date === d).reduce((s, p) => s + p.amount, 0); return running; });
  const timeData = {
    labels: periods,
    datasets: [{ data: cumData, borderColor: '#3ea4b1', backgroundColor: 'rgba(62,164,177,0.08)', pointBackgroundColor: '#3ea4b1', pointRadius: 4, tension: 0.3, fill: true }],
  };

  const barOpts = { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false }, tooltip: { callbacks: { label: ctx => '$' + ctx.parsed.y.toFixed(2) } } }, scales: { x: { grid: { display: false }, ticks: { color: TC, font: { size: 11 } } }, y: { grid: { color: GC }, ticks: { color: TC, font: { size: 11 }, callback: v => '$' + (v / 1000).toFixed(1) + 'k' } } } };
  const lineOpts = { responsive: true, maintainAspectRatio: false, plugins: { legend: { display: false }, tooltip: { callbacks: { label: ctx => '$' + ctx.parsed.y.toFixed(2) } } }, scales: { x: { grid: { display: false }, ticks: { color: TC, font: { size: 10 }, maxRotation: 45 } }, y: { grid: { color: GC }, ticks: { color: TC, font: { size: 11 }, callback: v => '$' + (v / 1000).toFixed(1) + 'k' } } } };

  const filtered = filter === 'all' ? payouts : payouts.filter(p => p.owner === filter);

  return (
    <div>
      <div className="metrics">
        <MetricCard label="Total paid out" value={fmtDec(total)} sub="2026 YTD" />
        <MetricCard label="Transactions" value={payouts.length} sub={'Across ' + repNames.length + ' reps'} />
        <MetricCard label="Largest payment" value={fmtDec(largest.amount)} sub={largest.owner.split(' ')[0] + ' · ' + largest.date} />
        <MetricCard label="Most recent" value={periods[periods.length - 1] || '—'} sub="Last payout date" />
      </div>

      <div className="two-col" style={{ marginTop: 20 }}>
        <div className="chart-card">
          <div className="chart-card-title">Payouts by rep</div>
          <div className="chart-card-sub">Total paid out 2026 YTD</div>
          <div className="chart-wrap" style={{ height: 220 }}><Bar data={repBarData} options={barOpts} /></div>
        </div>
        <div className="chart-card">
          <div className="chart-card-title">Payouts over time</div>
          <div className="chart-card-sub">Cumulative by pay period</div>
          <div className="chart-wrap" style={{ height: 220 }}><Line data={timeData} options={lineOpts} /></div>
        </div>
      </div>

      <div className="table-card">
        <div className="table-header">
          <span className="table-header-title">All payout transactions</span>
          <select value={filter} onChange={e => setFilter(e.target.value)} style={{ fontSize: 12, padding: '4px 8px', borderRadius: 'var(--radius-sm)', border: '1px solid var(--border)', fontFamily: 'var(--font)', color: 'var(--text2)' }}>
            <option value="all">All reps</option>
            {repNames.map(n => <option key={n} value={n}>{n}</option>)}
          </select>
        </div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Date</th><th>Rep</th><th>Amount</th><th>Notes</th></tr></thead>
            <tbody>
              {[...filtered].reverse().map((p, i) => (
                <tr key={i}>
                  <td className="td-num">{p.date}</td>
                  <td style={{ fontWeight: 500 }}>{p.owner}</td>
                  <td className="td-money">${p.amount.toFixed(2)}</td>
                  <td style={{ fontSize: 12, color: 'var(--text2)', maxWidth: 340, whiteSpace: 'normal' }}>{p.notes}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
